<template>
  <transition name="spinner-modal">
      <div :class="{ 'spinner-mask' : mask }">
          <div class="spinner-element">
            <div v-if="text === undefined" class="spinner-element-text">{{ $t('loading') }}</div>
            <div v-if="text !== undefined" class="spinner-element-text">{{ text }}</div>

            <div class="preloader-wrapper big active">
              <div class="spinner-layer spinner-white-only">
              <div class="circle-clipper left">
                  <div class="circle"></div>
              </div><div class="gap-patch">
                  <div class="circle"></div>
              </div><div class="circle-clipper right">
                  <div class="circle"></div>
              </div>
              </div>
            </div>
          </div>
      </div>
    </transition>
</template>
<script>
export default {
  name: 'spinner',
  props: {
    text: { type: String, default: () => '' },
    mask: { type: Boolean, default: () => false }
  }
}
</script>
<style>
.spinner-mask {
  position: absolute;
  z-index: 9998;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .2);
  transition: opacity .3s ease;
}
.spinner-element {
  max-height: calc(100% - 100px);
  position: fixed;
    top: 50%;
    left: 50%;
  transform: translate(-50%, -50%);
}
.spinner-element-text {
  color: rgba(0, 0, 0, .5);
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
}
.spinner-white,
.spinner-white-only {
  border-color: rgba(0, 0, 0, .5);
}
.active .spinner-layer.spinner-white {
  /* durations: 4 * ARCTIME */
  -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, white-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
  animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, white-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
}
.active .spinner-layer.spinner-white-only {
  /* durations: 4 * ARCTIME */
  opacity: 1;
  -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
  animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
}
@-webkit-keyframes white-fade-in-out {
  from {
    opacity: 0;
  }
  65% {
    opacity: 0;
  }
  75% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes white-fade-in-out {
  from {
    opacity: 0;
  }
  65% {
    opacity: 0;
  }
  75% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.spinner-modal-enter {
  opacity: 0;
}

.spinner-modal-leave-active {
  opacity: 0;
}

.spinner-modal-enter .spinner-modal-container,
.spinner-modal-leave-active .spinner-modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue